/*
  英语
*/
export default {
  Components: {
    ShoppingCart: {
      Tips1: 'Select products in same warehouse to put an order.',
      ShipFrom: 'Ship from',
      Delete: 'Delete',
      ProductHasBeenDiscontinued: 'Product has been discontinued',
      Tips2: 'Are you sure to delete this item？',
      Tips3: 'Your Shopping Bag is Empty!',
      SoldOut: 'Out of Stock',
      Total: 'Total',
      ShippingCalculation: 'Shipping Calculation',
      Tips4: 'Shopping bag has',
      Tips5: '3 warehouses',
      Tips6: 'of products',
      Tips7: 'You can choose products from the same warehouse to calculate the freight for you',
      ShippingTo: 'Shipping To',
      Select: 'select',
      ShippingMehod: 'Shipping Mehod',
      Description: 'Description',
      Qty: 'Qty',
      UnitPrice: 'Unit Price',
      Weight: 'Weight',
      Tips8: 'Select products in same warehouse to put an order',
      Submit: 'Submit'
    },
    SelectStoreToPublish: {
      Tips1: 'Select the store to publish',
      Tips2: 'List to Store',
      Platform: 'Platform',
      Store: 'Store',
      Cancel: 'Cancel',
      Submit: 'Submit',
      AllowStoreBinding: 'Allow store binding',
      NOStoreFound: 'NO Store Found',
      ConnectANewStore: 'Connect a New Store',
      SP: 'SP',
      Shopify: 'Shopify',
      Tips3: 'Please select a platform',
      Tips4: 'Please select a store'
    },
    QianHai: {
      title: 'Credit Card',
      CreditCard: 'Credit Card'
    },
    Product: {
      SoldOut: 'Out of Stock',
      New: 'NEW',
      Sale: 'SALE',
      Sales: 'Sales',
      LoginHint: 'Sign up for Kakaclo to unlock Wholesale Price',
      DetailHint: 'Failed to get product details, please contact customer service team'
    },
    NewFunction: {
      Notification: 'Notification',
      Events: 'Events',
      SoldOutList: 'Sold-out List',
      ExportList: 'Export List',
      UpdateTime: 'update time'
    },
    InformBox: {
      Notification: 'Notification',
      Events: 'Events',
      SoldOutList: 'Sold-out List',
      ExportList: 'Export List',
      NoRecordsFound: 'No Records Found',
      ViewAll: 'View All'
    },
    HelpCenter: {
      Tutorial: 'Tutorial',
      Tips1: 'KakaClo Tutorial: 1-Connect KakaClo to Shopify',
      YouTubeVideoPlayer: 'YouTube video player',
      Tips2: 'A.To connect your Shopify store, click the “Order” or “Product” buttons in the upper right corner to get into your backend.',
      Tips3: 'KakaClo Tutorial: 2- How to find and list products on KakaClo?',
      Tips4: 'In this section, you’ll learn:',
      Tips5: '1. How to find the products that you want to sell from KakaClo',
      Tips6: '2. How to list products on your Shopify store.',
      Tips7: '3. How to make changes to photos, variance, and pricing of your product.',
      Tips8: 'KakaClo Tutorial: 3- How to Edit Your Order?',
      Tips9: 'Click the “Order” button to access all orders that are placed in your backend.',
      Tips10: 'On this page, there are 4 main types of state for an order: Awaiting payment, Pending, In Transit, and In Refund.',
      HelpCenter: 'Help center'
    },
    CardDialog: {
      AddCard: 'Add Card',
      SecurityCode: 'Security Code',
      CardNo: 'Card No',
      ExpireDate: 'Expire Date',
      BillingAddress: 'Billing Address',
      FullName: 'Full Name',
      PhoneNumber: 'Phone Number',
      StreetAddressLine1: 'Street Address Line 1',
      StreetAddressLine2: 'Street Address Line 2',
      City: 'City',
      StateProvinceRegion: 'State/Province/Region',
      Country: 'Country',
      ZipCode: 'Zip Code',
      InputContent: 'Input Content',
      Cancel: 'Cancel',
      Submit: 'Submit'
    },
    Airwallex: {
      Airwallex: 'Airwallex'
    },
    AccountSettingDialog: {
      Tips1: 'You can resend the code after',
      Tips2: 's later',
      Tips3: 'Please enter your vaild email',
      Tips4: 'The two passwords are inconsistent',
      PleaseEnter: 'Please enter',
      Tips5: 'The mailbox format is incorrect'
    },
    Mobile: {
      SelectPaymentMethod: {
        CustomizedService: 'Customized Service',
        Tags: 'Tags',
        Tips1: 'Package',
        Tips2: 'Bags'
      },
      SearchBar: {
        SearchingFor: 'Searching for'
      },
      Header: {
        BackToShopping: 'Back to Shopping'
      },
      AddressDialog: {
        FullName: 'Full Name',
        PhoneNumber: 'Phone Number',
        StreetAddressLine1: 'Street Address Line 1',
        StreetAddressLine2: 'Street Address Line 2',
        City: 'City',
        StateProvinceRegion: 'State/Province/Region',
        ZipCode: 'Zip Code',
        VAT: 'VAT',
        IOSS: 'IOSS'
      }
    },
    Common: {
      UpgradeBox: {
        Tips1: 'System update is processing',
        OK: 'OK'
      }
    }
  }
}
